import { ClearOutlined, SearchOutlined } from "@ant-design/icons";
import { ReactComponent as AddIcon } from "@src/styles/icon/add.svg";
import { Button, Col, Collapse, Empty, Form, Input, Layout, Row, Select } from "antd";
import { offset } from "highcharts";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { VideoApi } from "../../api/backend/video";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import { KEY, lang, TAB_VIDEO } from "../../constants/common.const";
import {
  getQuerySearch,
  handleCatchError,
  pushObject2Query,
} from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classGrid from "../../models/control/grid";
import ListVideoByCate from "./listVideoByCate";
import TabVideo from "./tabVideo";
import ListPlayList from "./listPlayList";
import { setCurrentTab } from "../../redux/video";
import { useLocation } from "react-router-dom";
import ListVideoInstruction from "./listVideoInstruction";
import ListVideoRecent from "./listVideoRecent";
import InfiniteScroll from "react-infinite-scroller";
import LoadingInline from "../../component/Popup/loading-inline";

// import { ReactComponent as AddIcon } from "@src/styles/icon/add.svg";

const { Content } = Layout;

function ListVideo() {
  const LIMIT_CATE = 10;
  const LIMIT_VIDEO = 20;
  const getInittag = () => {
    if (objSearch.tag) {
      return "#" + objSearch.tag;
    }
    return objSearch.keyword || "";
  };
  const location = useLocation();

  const objSearch = getQuerySearch();
  const [formSearch] = Form.useForm();
  const isPC = useMediaQuery({ query: KEY.LAPTOP_WIDTH });
  const [showLoading, setShowLoading] = useState(false);
  const dispatch = useDispatch();
  const [grid, setGrid] = useState([]);
  const [textSearch, setTextSearch] = useState(getInittag());
  const history = useHistory();
  const [loadingInline,setLoadingInline] = useState(false)

  const search_onClick = () => {
    // Logic to search data
  };

  // List VIDEO
  const [listVideoAllCate, setListVideoAllCate] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });
  const [listVideoAllOffice, setListVideoAllOffice] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });

  const [listVideoCurrentOffice, setListVideoCurrentOffice] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });

  const [listVideoPlaylist, setListVideoPlaylist] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });

  const [listVideoRecent, setListVideoAllRecent] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });
  const [listVideoIntruction, setListVideoIntruction] = useState({
    ...new classGrid(),
    textSearch: getInittag(),
  });

  const getStateListByActiveKey = (key) => {
    switch (activeKey.key) {
      case TAB_VIDEO.ALL_CATEGORY: {
        return [listVideoAllCate, setListVideoAllCate];
      }
      case TAB_VIDEO.ALL_OFFICE: {
        return [listVideoAllOffice, setListVideoAllOffice];
      }
      case TAB_VIDEO.CURRENT_OFFICE: {
        return [listVideoCurrentOffice, setListVideoCurrentOffice];
      }
      case TAB_VIDEO.PLAYLIST: {
        return [listVideoPlaylist, setListVideoPlaylist];
      }
      case TAB_VIDEO.RECENT: {
        return [listVideoRecent, setListVideoAllRecent];
      }
      case TAB_VIDEO.SYSTEM_INSTRUCTION: {
        return [listVideoIntruction, setListVideoIntruction];
      }
      default:
        return [listVideoAllCate, setListVideoAllCate];
    }
  };

  const { selectedFactory, userName } = useSelector((state) => state.auth);
  const filters = [
    { label: "すべて", key: TAB_VIDEO.ALL_CATEGORY, params: {} },
    { label: "共通", key: TAB_VIDEO.ALL_OFFICE, params: { isCount: true } },
    {
      label: "事業所所属",
      key: TAB_VIDEO.CURRENT_OFFICE,
      params: {
        siteOfficeCode: selectedFactory,
        islogin: true,
      },
    },
    {
      label: "マイプレイリスト",
      key: TAB_VIDEO.PLAYLIST,
      params: {
        userName,
      },
    },
    {
      label: "最近アップロードされた動画",
      key: TAB_VIDEO.RECENT,
      params: {
        day: true,
      },
    },
    {
      label: "システム取扱動画",
      key: TAB_VIDEO.SYSTEM_INSTRUCTION,
      params: {},
    },
  ];

  const currentKey = !isNaN(objSearch.tab) ? String(objSearch.tab) : "1";
  const getTab = () => {
    const currentTab = filters.find((i) => i.key == currentKey);
    return currentTab || filters[0];
  };
  const [activeKey, setActiveKey] = useState(getTab());

  const LIMIT =
    activeKey.key == TAB_VIDEO.PLAYLIST ||
    activeKey.key == TAB_VIDEO.RECENT ||
    activeKey.key === TAB_VIDEO.SYSTEM_INSTRUCTION
      ? LIMIT_VIDEO
      : LIMIT_CATE;
  const [currentList, setCurrentList] = getStateListByActiveKey(activeKey.key);

  // UPDATE DELETE
  const updateDeleteList = useCallback(
    (id) => {
      setCurrentList((prevList) => {
        const newList = { ...prevList };
        const data = [...newList.data];

        const indexData = data.findIndex((item) =>
          item.videoDetailDTOs.some((video) => video.id == id)
        );

        if (indexData >= 0) {
          const listCurrent = data[indexData].videoDetailDTOs;
          const filteredVideos = listCurrent.filter((video) => video.id != id);

          data[indexData] = {
            ...data[indexData],
            videoDetailDTOs: filteredVideos,
          };

          return {
            ...newList,
            data,
          };
        }

        return prevList;
      });
    },
    [currentList]
  );

  // UPDATE DELETE
  const updateAddPlayList = useCallback(
    (id) => {
      setCurrentList((prevList) => {
        const newList = { ...prevList };
        const data = [...newList.data];

        const indexData = data.findIndex((item) =>
          item.videoDetailDTOs.some((video) => video.id == id)
        );
       
        if (indexData >= 0) {
          const listCurrent = data[indexData].videoDetailDTOs;
          const indexVideo = listCurrent.findIndex(video => video.id == id );
          if(indexVideo > 0){
            listCurrent[indexVideo].isVideoPlayList = true
          }

          data[indexData] = {
            ...data[indexData],
            videoDetailDTOs: listCurrent,
          };

          return {
            ...newList,
            data,
          };
        }

        return prevList;
      });
    },
    [currentList]
  );


  const updateDeletePlaylist = useCallback(
    (id) => {
      setCurrentList((prevList) => {
        const newList = { ...prevList };
        const data = [...newList.data];

        const filteredVideos = data.filter((video) => video.id != id);

        return {
          ...newList,
          data: filteredVideos,
        };
      });
    },
    [currentList]
  );

  // ADD PLAYLIST
  const updateAddPlayListNocate = useCallback(
    (id) => {
      setCurrentList((prevList) => {
        const newList = { ...prevList };
        const data = [...newList.data];

      const index = data.findIndex(video => video.id == id);
      if(index > 0){
        data[index].isVideoPlayList = true
      }

        return {
          ...newList,
          data,
        };
      });
    },
    [currentList]
  );

  function parseText(input) {
    if (typeof input !== "string" || !input.trim()) {
      return { isTag: false, value: "" };
    }

    const trimmed = input.trim();

    if (trimmed.startsWith("#")) {
      return {
        isTag: true,
        value: trimmed.slice(1),
      };
    }

    return {
      isTag: false,
      value: trimmed,
    };
  }

 
  // SEARCH
  const getListVideo = async (
    params = {},
    isInit,
    isSearch,
    isClear,
    text = ""
  ) => {
    try {
      if (isSearch) {
        setShowLoading(true);
      }
      setLoadingInline(true)
      const finalTextSearch = text || textSearch;
      const [listVideo, setListVideo] = getStateListByActiveKey(activeKey.key);
      const { isTag, value } = parseText(finalTextSearch);
      let res;
      const finalParams = {
        ...params,
        title: isClear ? "" : !isTag ? value : "",
        searchTagName: isClear ? "" : isTag ? value : "",
        limit: LIMIT,
        offset: 0,
      };
      if (activeKey.key === TAB_VIDEO.PLAYLIST) {
        res = await VideoApi.getAllVideoPlayList(finalParams);
      } else if (activeKey.key === TAB_VIDEO.SYSTEM_INSTRUCTION) {
        res = await VideoApi.getAllVideoInstruction(finalParams);
      } else if (activeKey.key === TAB_VIDEO.RECENT) {
        res = await VideoApi.getAllVideoRecent(finalParams);
      } else {
        res = await VideoApi.getManualVideos(finalParams);
      }
      if (
        activeKey.key === TAB_VIDEO.PLAYLIST ||
        activeKey.key === TAB_VIDEO.SYSTEM_INSTRUCTION ||
        activeKey.key === TAB_VIDEO.RECENT
      ) {
        setListVideo({
          ...listVideo,
          data: res.data,
          hasMoreData: res.data.length > 0,
          isFetch: false,
          offset:  LIMIT,
        });
      } else {
        setListVideo({
          ...listVideo,
          data: res.data.data,
          hasMoreData: res.data.data.length > 0,
          isFetch: false,
          offset:  LIMIT,
        });
      }
      // PUSH URL
      pushObject2Query({
        keyword: isClear ? "" : !isTag ? value : "",
        tab: activeKey.key,
        tag: isClear ? "" : isTag ? value : "",
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
      setLoadingInline(false)
    }
  };
  useEffect(() => {
    const [listVideo] = getStateListByActiveKey(activeKey.key);
    if (!listVideo.isFetch) {
      getListVideo(activeKey.params);
    }
    dispatch(setCurrentTab(activeKey.key));
  }, [activeKey.key]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; 
      return;
    }
    const params = new URLSearchParams(location.search);
    const keyword = params.get("tag");
    const tab = params.get("tab");
      setTextSearch(getInittag());
      getListVideo(activeKey.params, true, true, false, getInittag());
    
  }, [location.search]);

  // FETCH MORE
  const fetchMoreData = async () => {
    if(loadingInline)return;
    try {
      setLoadingInline(true)
      const finalTextSearch = textSearch;
      const [listVideo, setListVideo] = getStateListByActiveKey(activeKey.key);
      const { isTag, value } = parseText(finalTextSearch);
      let res;
      const finalParams = {
        ...activeKey.params,
        title: !isTag ? value : "",
        searchTagName: isTag ? value : "",
        limit: LIMIT,
        offset: listVideo.offset || 0,
      };
      if (activeKey.key === TAB_VIDEO.PLAYLIST) {
        res = await VideoApi.getAllVideoPlayList(finalParams);
      } else if (activeKey.key === TAB_VIDEO.SYSTEM_INSTRUCTION) {
        res = await VideoApi.getAllVideoInstruction(finalParams);
      } else if (activeKey.key === TAB_VIDEO.RECENT) {
        res = await VideoApi.getAllVideoRecent(finalParams);
      } else {
        res = await VideoApi.getManualVideos(finalParams);
      }
      if (
        activeKey.key === TAB_VIDEO.PLAYLIST ||
        activeKey.key === TAB_VIDEO.SYSTEM_INSTRUCTION ||
        activeKey.key === TAB_VIDEO.RECENT
      ) {
        setListVideo({
          ...listVideo,
          data: [...listVideo.data, ...res.data],
          hasMoreData: res.data.length > 0,
          offset: (listVideo.offset || 0) + LIMIT,
        });
      } else {
        setListVideo({
          ...listVideo,
          data: [...listVideo.data, ...res.data.data],
          hasMoreData: res.data.data.length > 0,
          offset: (listVideo.offset || 0) + LIMIT,
        });
      }
    } catch (error) {}
    finally{
      setLoadingInline(false)
    }
  };
  return (
    <div className="des-content">
      <TitlePage name={"動画管理"} />
      <Content
        className="site-layout-background"
        style={{
          margin: "24px 16px",
          padding: 24,
        }}
      >
        <Form
          layout={"vertical"}
          name="searchCL"
          className="formStyle"
          form={formSearch}
          onFinish={search_onClick}
        >
          <Row gutter={[8, isPC ? 0 : 16]} align="bottom">
            <Col span={isPC ? 6 : 24}>
              <div style={{ marginBottom: 4, fontWeight: 600 }}>
                {lang.TITLE}
              </div>

              <Input
                value={textSearch}
                onChange={(e) => setTextSearch(e.target.value)}
                allowClear
                maxLength={255}
                placeholder={lang.TITLE}
              />
            </Col>
            <Col
              span={isPC ? 8 : 24}
              style={{ display: "flex", alignItems: "end" }}
            >
              <Button
                onClick={() => getListVideo(activeKey.params, true, true)}
                className="buttonPC button--info wAuto"
                htmlType="submit"
              >
                <SearchOutlined /> {lang.SEARCH}
              </Button>
              <Button
                className="buttonPC button--outline --todo-- wAuto ml10"
                onClick={() => {
                  getListVideo(activeKey.params, true, true, true);
                  setTextSearch("");
                }}
              >
                <ClearOutlined /> クリアー
              </Button>
            </Col>
          </Row>
        </Form>
      </Content>
      <Content
        className={isPC && "site-layout-background"}
        style={{ margin: "24px 16px", padding: isPC ? 24 : 0 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TabVideo
            activeKey={activeKey.key}
            setActiveKey={setActiveKey}
            tabs={filters}
          />
          <Button
            type="link"
            className="btnAddRecord mb15"
            onClick={() => {
              history.push("/VideoManagement/Add");
            }}
          >
            <AddIcon />
            {lang.ADD}
          </Button>
        </div>
        {/* LIST VIDEO */}
       {
        currentList.data.length > 0 ?  <InfiniteScroll
        pageStart={0}
        loadMore={() => {
          fetchMoreData();
        }}
        hasMore={currentList.hasMoreData}
        loader={
          <div className="center" key={0}>
            <LoadingInline isLoadingInline={true} />
          </div>
        }
        useWindow={true}
      >
        <div className="mt10">
          {activeKey.key == TAB_VIDEO.SYSTEM_INSTRUCTION ? (
            <ListVideoInstruction
              list={currentList.data}
              updateDeleteList={updateDeletePlaylist}
              callBackAddPlayList={updateAddPlayListNocate}
            />
          ) : activeKey.key == TAB_VIDEO.PLAYLIST ? (
            <ListPlayList
              list={currentList.data}
              updateDeleteList={updateDeletePlaylist}
              callBackAddPlayList={updateAddPlayListNocate}
            />
          ) : activeKey.key == TAB_VIDEO.RECENT ? (
            <ListVideoRecent
              list={currentList.data}
              updateDeleteList={updateDeletePlaylist}
              callBackAddPlayList={updateAddPlayListNocate}
            />
          ) : (
            <ListVideoByCate
              updateDeleteList={updateDeleteList}
              list={currentList}
              callBackAddPlayList={updateAddPlayList}
            />
          )}
        </div>
      </InfiniteScroll>:<div className="center">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </div>
       }
      </Content>

      <Loading show={showLoading} />
    </div>
  );
}

export default ListVideo;
